export default function Modal({ title, open, onClose, children }) {
    if (!open) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(22, 59, 22, 0.5)' }}>
            <div className="w-full max-w-2xl rounded-2xl border-2 border-green-600 bg-green-50 p-6 shadow-2xl">
                <div className="flex items-center justify-between pb-4 border-b-2 border-green-600/20">
                    <h2 className="text-2xl font-bold text-green-700">{title}</h2>
                    <button
                        className="rounded-lg bg-green-600 px-4 py-2 text-sm text-green-900 hover:bg-green-700 transition font-semibold"
                        onClick={onClose}
                    >
                        Fermer
                    </button>
                </div>
                <div className="space-y-4 mt-4 text-green-900">{children}</div>
            </div>
        </div>
    );
}
